module.exports = __webpack_public_path__ + "static/PeekSkull-de1604eec8553e1d9c2c3928ae3230d9.png";